import React from 'react';
import { Icon } from './Icon.js';
export const IconCarGarage = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M20 21V13.5L18 12.5L16.5 9H7.5L6 12.5L4 13.5V21H7.5L8 19H16L16.5 21H20Z", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M8.01 16H8", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M16.01 16H16", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M22 5.38184V7.61816L12 2.61816L2 7.61816V5.38184L12 0.381836L22 5.38184Z", fill: "currentColor", "data-stroke": "none" })));
};
//# sourceMappingURL=IconCarGarage.js.map